import { FC } from "react";

import { SvgIconConstituentValues } from "types/common";

export const HealhyPerkIcon: FC<SvgIconConstituentValues> = ({
  fill,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke={fill || "#646965"}
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M8.5 13.5C9.5 15 11 17 12 17C13 17 14.5 15 15.5 13.5"
      stroke={fill || "#646965"}
      strokeWidth="1.5"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M9 10C9 8.89543 9.89543 8 11 8C12.1046 8 13 8.89543 13 10"
      stroke={fill || "#646965"}
      strokeWidth="1.5"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M7.5 10.5C7.5 10.5 8.5 7.5 12 7.5C15.5 7.5 16.5 10.5 16.5 10.5"
      stroke={fill || "#646965"}
      strokeWidth="1.5"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);
